function resolveRoleDoc(user, roles) {
    const roleId = user?.role?.id
    if (!roleId) return null

    const list = Array.isArray(roles) ? roles : []
    return list.find(role => String(role?._id) === String(roleId)) || null
}

function deriveRoleFlags(user, roles) {
    const roleDoc = resolveRoleDoc(user, roles)
    const roleName = String(roleDoc?.name || user?.role?.name || '').toLowerCase()

    return {
        roleDoc,
        isAdmin: roleName.includes('admin'),
        permissions: roleDoc?.permissions || [],
        canExportClientInfoForm: !!roleDoc?.canExportClientInfoForm,
        canFilterByFYE: !!roleDoc?.canFilterByFYE,
        canFilterByMonthOfAgreement: !!roleDoc?.canFilterByMonthOfAgreement,
        canAddClientDocumentRecord: !!roleDoc?.canAddClientDocumentRecord,
        canDeleteClientDocumentRecord: !!roleDoc?.canDeleteClientDocumentRecord,
        canViewReports: !!roleDoc?.canViewReports,
        canViewQualityReview: !!roleDoc?.canViewQualityReview,
        canDeleteReports: !!roleDoc?.canDeleteReports,
        canExportReports: !!roleDoc?.canExportReports
    }
}

export { resolveRoleDoc, deriveRoleFlags }
